module.exports = __webpack_public_path__ + "static/media/post-connection.55002b6d.svg";